<template>
	<div class="Loginbox">
		<div class="paddingBox">
			<div class="headTitle" v-if="isshow">
				<div>请先登录</div>
				<img src="../../assets/close.svg" alt="" />
			</div>
			<div v-if="isActive3 == false">
				<div class="imgBox">
					<div class="wxLoginBox">
						<div class="picTitle">
							<img src="@/assets/wxTitle.png" alt="" />
						</div>
						<div style="cursor: pointer" class="wxBox">
							<img src="@/assets/wxCode.png" alt="" @click="scanningLogin" />
						</div>
					</div>
				</div>

				<div class="infoBox">
					<div class="tabs">
						<div
							:class="{ischoose: isActive1}"
							@click="changeBtn1('1')"
							style="cursor: pointer"
						>
							密码登录
						</div>
						<div
							:class="{ischoose: isActive2}"
							@click="changeBtn2('2')"
							style="cursor: pointer"
						>
							验证码登录
						</div>
					</div>

					<!-- <passwordLogin
						v-if="isActive1 == true"
						v-on="$listeners"
					></passwordLogin>
					<verificationCode
						v-if="isActive2 == true"
						v-on="$listeners"
					></verificationCode> -->
					<keep-alive>
						<component
							ref="tab"
							:is="currentTab"
							@closeDialog="closeDialog"
						></component>
					</keep-alive>
				</div>
			</div>

			<!-- <scanningLogin
				v-if="isActive3 == true"
				@getIsActive3="getIsActive3"
			></scanningLogin> -->
			<div class="signText">
				<router-link to="/forgetPassword"
					><div class="colorHover">忘记密码</div></router-link
				><span class="spanColor" @click="goReister">立即注册 </span>
			</div>
		</div>
	</div>
</template>

<script>
// import scanningLogin from "./components/scanningLogin.vue"
import passwordLogin from "./components/passwordLogin.vue"
import verificationCode from "./components/verificationCode.vue"
export default {
	components: {passwordLogin, verificationCode},
	data() {
		return {
			activeName: "second",
			isActive1: true,
			isActive2: false,
			isActive3: false,
			currentTab: "passwordLogin",
			isshow: false
		}
	},
	watch: {
		isActive3(e) {
			// console.log(e)
			// console.log(this.isActive1, this.isActive2)
		}
	},
	methods: {
		closeDialog(e) {
			this.$emit("closeLoginDialog", e)
		},
		getIsActive3(e) {
			this.isActive3 = e
			// console.log(e)
			this.$emit("getIsActive3", this.isActive3)
		},
		handleClick(tab, event) {
			console.log(tab, event)
		},
		scanningLogin() {
			console.log("微信扫码")
			window.location.href =
				"https://open.weixin.qq.com/connect/qrconnect?appid=wx52cd6a8fe3fbe426&redirect_uri=http://www.peiqimall.com/wxcallback&response_type=code&scope=snsapi_login&state=STATE_123456#wechat_redirect"
			//this.isActive3 = !this.isActive3
			// console.log(this.isActive3)
			//this.$emit("getIsActive3", this.isActive3)
			// this.isActive2 = false
			// this.isActive1 = false
		},
		goReister() {
			this.$router.push("/register")
		},
		changeBtn1(e) {
			// if (this.isActive1 == true && this.isActive2 !== true) {
			// 	return
			// } else if (this.isActive2 !== true && this.isActive1 == true) {
			// 	this.isActive1 = true
			// 	this.isActive2 = false
			// }
			if (this.isActive1 == true && this.isActive2 !== true) {
				return
			} else if (this.isActive1 !== true && this.isActive2 == true) {
				this.isActive1 = true
				this.isActive2 = false
				this.currentTab = "passwordLogin"
			}
			console.log(this.isActive1, this.isActive2)
		},
		changeBtn2(e) {
			if (this.isActive2 == true && this.isActive1 !== true) {
				return
			} else if (this.isActive1 == true && this.isActive2 !== true) {
				this.isActive1 = false
				this.isActive2 = true
				this.currentTab = "verificationCode"
			}
			console.log(this.isActive1, this.isActive2)
		}
	},
	mounted() {}
}
</script>

<style lang="scss" scoped>
.Loginbox {
	// margin: 100px auto;
	// width: 350px;
	// height: 413px;
	width: 100%;
	height: auto;
	padding: 0 0 10px 0;
	background: #ffffff;
	.imgBox {
		position: relative;
		.wxLoginBox {
			position: absolute;
			top: 0;
			right: 0px;
			// float: right;
			height: 0;
			display: flex;

			.picTitle {
				float: right;
				width: 116px;
				height: 17px;
				margin-top: 10px;
				img {
					width: 100%;
					height: auto;
				}
			}
			.wxBox {
				float: right;
				margin: 10px 10px 0 4px;
				width: 68px;
				height: 68px;
				margin-top: 10px;
				img {
					width: 100%;
					height: auto;
				}
			}
		}
	}
	.headTitle {
		display: flex;
		flex: 1;
		height: 36px;
		line-height: 36px;
		color: #7c7d7d;
		justify-content: space-between;
		padding: 0 10px;
		background: #f2f4f5;
		img {
			width: 12px;
		}
	}
	.infoBox {
		padding: 30px 20px 0 20px;
	}
	.tabs {
		display: flex;
		flex: 1;
		// width: 100%;
		margin-top: 10px;
		margin-bottom: 20px;
		font-size: 20px;
		// background: pink;

		div:first-child {
			margin-right: 32px;
		}
		div {
			// flex: 1;
			// margin-right: 32px;
			// display: flex;
			// flex: 1;
		}
	}
	.isgrey {
		color: #b8b8b8;
	}
	.ischoose {
		color: #ff4f1a;
		font-weight: 700;
		padding-bottom: 2px;
		border-bottom: 2px solid #ff4f1a;
	}
	.signText {
		display: flex;
		justify-content: flex-end;
		margin-right: 22px;
		margin-top: 30px;
		text-align: center;
		font-size: 14px;
		span:first-child {
			color: #959699;
		}
		.spanColor {
			margin-left: 20px;
			cursor: pointer;
			color: #ff9475;
		}
	}
}
</style>
